import { render, staticRenderFns } from "./PoEntryCrew.vue?vue&type=template&id=63e5dbdc&scoped=true&"
import script from "./PoEntryCrew.vue?vue&type=script&lang=js&"
export * from "./PoEntryCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5dbdc",
  null
  
)

export default component.exports